<script>
import Layout from '@layouts/default'
import appConfig from '@src/app.config'
import Multiselect from 'vue-multiselect'

/**
 * Register component
 */
export default {
    page: {
        title: 'Регистрация',
        meta: [{ name: 'description', content: `Register to ${appConfig.title}` }],
    },
    components: { Layout, Multiselect },
    data() {
        return {
            fullname  : '',
            phone     : '+7',
            password  : '',
            sms_code  : '',
            agree     : false,
            show_code : false,
            trackBy   : 'id',
            regError  : null,
            confirm_uuid : null,
            tryingToRegister : false,
            isRegisterError  : false,
            iscompany : { id:'false',  name:'Физическое лицо' },
            iscompany_options: [
                { id:'false', name:'Физическое лицо' },
                { id:'true',  name:'Юридическое лицо' },
            ],
        }
    },
    computed: {},
    methods: {
        async resetCode(){
            this.show_code = false;
            this.sms_code  = '';
        },
        async tryToRegisterIn() {

            if(this.agree === false){

                this.isRegisterError = true;
                this.regError = 'Для продолжения регистрации необходимо ознакомиться и подтвердить свое согласие с пользовательским соглашением, политикой конфиденциальности и публичной оффертой';

                return false;
            }

            this.tryingToRegister = true;
            this.isRegisterError  = null;

            let data_send;
            let result;

            if(this.confirm_uuid == null){

                if(this.sms_code == ''){
                    // отправляем код
                    data_send = {
                        'phone': this.phone,
                    };
                } else {
                    data_send = {
                        'code'  : this.sms_code,
                        'phone' : this.phone
                    };
                }

                result = await this.$store.dispatch('users/FETCH_USERS_CONFIRM', data_send);

                if (result == false) {

                    this.tryingToRegister = false;
                    this.regError = 'Ошибка при подтверждении номера телефона';
                    this.isRegisterError = true;

                } else {

                    // показываем поле для ввода кода
                    this.show_code = true;

                    if(result !== null && result.confirm_uuid !== 'undefined'){
                        this.confirm_uuid = result.confirm_uuid;
                        let data_send = {
                            'phone'     : this.phone,
                            'name1'     : this.fullname,
                            'password'  : this.password,
                            'confirm_uuid': this.confirm_uuid
                        };

                        let new_session = await this.$store.dispatch('users/FETCH_USERS_REGISTRATION', data_send);

                        if (new_session == false) {
                            this.tryingToRegister = false;
                            this.regError = 'Ошибка при регистрации';
                            this.isRegisterError = true;
                        } else {
                            window.localStorage.setItem('API_KEY_ZABOTA', new_session.token);
                            this.$router.push({name: 'login'});
                        }
                    }
                }
            }
        },
    },
}
</script>

<template>
	<Layout>
        <div class="account-pages my-5">
			<div class="container">
				<div class="row justify-content-center" style="margin-left: 0px; margin-right: 0px">
					<div class="col-xl-4 form" style="max-width: 400px">
						<div class="card">
							<div class="card-body p-0">
								<div class="row">
									<div class="col p-5">

                                        <div class="mx-auto mb-5" style="margin-left: 30px !important; margin-bottom: 70px !important; margin-top: 10px !important">
                                            <a routerLink="/">
                                                <img src="@assets/images/logo.png" alt style="margin-left: -25px;"/>
                                            </a>
                                        </div>

										<div class="mx-auto mb-5">
											<a href="/">
												<h3 class="d-inline align-middle ml-1 text-logo"
													>Личный кабинет</h3
												>
											</a>
										</div>

										<h6 class="h5 mb-0 mt-4">Регистрация нового пользователя</h6>
										<p class="text-muted mt-0 mb-4"
											>Заполните поля ниже для регистрации личного кабинета</p
										>

                                        <b-alert
                                            v-model="isRegisterError"
                                            variant="danger"
                                            dismissible
                                        >{{ regError }}</b-alert
                                        >

										<b-form
                                              class="authentication-form"
                                              @submit.prevent="tryToRegisterIn"
                                        >
											<div class="form-group">
												<label class="form-control-label">Ваше имя</label>
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="user" class="icon-dual"></feather>
														</span>
													</div>
													<input
														id="name"
														type="text"
														class="form-control"
														placeholder="Введите ваше имя"
                                                        v-model="fullname"
														required
													/>
												</div>
											</div>

											<div class="form-group">
												<label class="form-control-label">Номер телефона</label>
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="phone" class="icon-dual"></feather>
														</span>
													</div>
													<input
														id="phone"
														type="phone"
														class="form-control"
														placeholder="Ваш номер телефона"
                                                        v-model="phone"
													/>
												</div>
											</div>

                                            <div class="form-group">
                                                <label class="form-control-label">Пароль</label>
                                                <div class="input-group input-group-merge">
                                                    <div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="lock" class="icon-dual"></feather>
														</span>
                                                    </div>
                                                    <input
                                                        id="password"
                                                        type="password"
                                                        class="form-control"
                                                        placeholder="Пароль"
                                                        v-model="password"
                                                    />
                                                </div>
                                            </div>

                                            <div v-show="show_code" class="form-group">
                                                <label class="form-control-label">Код подтверждения</label>
                                                <div class="input-group input-group-merge">
                                                    <div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="key" class="icon-dual"></feather>
														</span>
                                                    </div>
                                                    <input
                                                        id="sms_code"
                                                        type="number"
                                                        class="form-control"
                                                        placeholder="Код из СМС сообщения"
                                                        v-model="sms_code"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group mb-4" style="margin-top: 25px; margin-bottom: 35px">
                                                <div class="custom-control custom-checkbox">
                                                    <input
                                                        id="checkbox-signup"
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        v-model="agree"
                                                    />
                                                    <label
                                                        class="custom-control-label"
                                                        for="checkbox-signup"
                                                        style="font-weight: normal; font-size: 12px"
                                                    >
                                                        Регистрируясь в сервисе ZA| BOTA вы подтверждаете свое согласие с
                                                        <a href="https://client.za-bota.com/docs/users_agreements.pdf">пользовательским соглашением</a> и подтверждаете, что ознакомлены и согласны с
                                                        <a href="https://za-bota.com/privacy_policy.pdf">политикой конфиденциальности</a> данного сервиса
                                                    </label>
                                                </div>
                                            </div>

											<div class="form-group mb-0 text-center">
												<button class="btn btn-primary btn-block" type="submit"
													>Зарегистрироваться</button
												>
											</div>

										</b-form>
                                        <div class="col-12 text-center" style="margin-top: 20px">
                                            <p class="text-muted">
                                                Есть аккаунт?
                                                <router-link
                                                    tag="a"
                                                    to="/"
                                                    class="text-primary font-weight-bold ml-1"
                                                >Авторизироваться</router-link
                                                >
                                            </p>
                                        </div>
									</div>

								</div>
							</div>
							<!-- end card-body -->
						</div>
						<!-- end card -->

					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</div>
	</Layout>
</template>

<style lang="scss">

    .account-pages {
        width: 100vw; margin: 0 !important; min-height: 100vh;
    }

    .form-control {
        height: calc( 1.5em + 1rem + 3px );
    }

    .container {
        width: 100vw;
        margin: 0;
        padding: 0;
        max-width: 100vw !important;
        min-height: 100vh;
    }

    .card {
        -webkit-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        -moz-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
    }

    .row.justify-content-center {
        min-height: 100vh;
        align-items: center;
    }

    .row.justify-content-center .card {
        max-width: 400px;
    }

    .auth-page-sidebar {
        background-position-x: right;
        .overlay {
            display: none !important
        }
    }
</style>
